import React, { createContext, useContext, useState } from "react";
import Cookies from 'universal-cookie';
const cookie = new Cookies();
const AuthContext = createContext();




const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(cookie.get('token')||"");
    // const navigate = useNavigate();

    // useEffect(()=>{

    // },[])

    const logout = () => {
      // localStorage.setItem("token", "")
      // cookie.set('token', "", { path: '/', domain: window.location.hostname });
      cookie.remove("token", { path: '/', domain: window.location.hostname })
      cookie.remove("refresh", { path: '/', domain: window.location.hostname })
      cookie.remove("is_crew", { path: '/', domain: window.location.hostname })
      cookie.remove("is_user", { path: '/', domain: window.location.hostname })
      cookie.remove("is_customer", { path: '/', domain: window.location.hostname })
      cookie.remove("user", { path: '/', domain: window.location.hostname })

      setToken("");

      console.log(token, ":::::::")
    }

    const login = async (data) => {
      // console.log(JSON.stringify(data), "########")
      // localStorage.setItem("token", data);
      cookie.set('token', data.access, { path: '/', domain: window.location.hostname });
      cookie.set('refresh', data.refresh, { path: '/', domain: window.location.hostname });

      cookie.set('is_crew', data.is_crew_user, { path: '/', domain: window.location.hostname });
      cookie.set('is_user', data.is_customer_user, { path: '/', domain: window.location.hostname });

      cookie.set('is_customer', data.is_customer_user, { path: '/', domain: window.location.hostname });
      const userData = {
        "email": data.email,
        "first_name": data.first_name,
        "last_name": data.last_name,
        "phone_number": data.phone_number,
        "id": data.id
      }
      cookie.set('user', JSON.stringify(userData), { path: '/', domain: window.location.hostname });



      console.log(data, "#########")
      if(data.store){
        let default_store = data.store.find((item) => item.is_default)
        console.log(default_store, "&&&&&&&&&&")
        // console.log(default_store, "&&&&&&&&&&")
        if(default_store){
          cookie.set('store', default_store.store.id.toString(), { path: '/', domain: window.location.hostname });
        }
      }




      // Wait for state update to complete
        console.log(data.access, "AAAA")
        setToken(data.access);

        localStorage.setItem("colorschema", "orange");
        localStorage.setItem("layout", "vertical");
        localStorage.setItem("layoutwidth", "fixed");
        localStorage.setItem("layoutpos", "fluid");
        localStorage.setItem("topbartheme", "light");
        localStorage.setItem("layoutSized", "lg");
        localStorage.setItem("layoutStyling", "default");
        localStorage.setItem("layoutSidebarStyle", "dark");
        localStorage.setItem("layoutSidebarStyle", "dark");
        
        
    };
  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthContext, AuthProvider, useAuth };
